import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { MUTATION_KEYS } from '@avanta/shared/constants/common';
import { PatientService } from '@avanta/shared/services/patients';

export type DeletePatientVariables = {
  userId: string;
  redirect?: boolean;
};

export const useDeletePatient = (): UseMutationResult<void, Error, DeletePatientVariables> =>
  useMutation({
    mutationKey: [MUTATION_KEYS.DELETE_PATIENT],
    mutationFn: async ({ userId, redirect }: DeletePatientVariables) => {
      await PatientService.deletePatient(userId, redirect);
    },
  });
